import { Text } from "@chakra-ui/react";
import { useFindAreaComum } from "core/features/area-comum/hooks";
import useDeleteImagensAreaComum from "core/features/area-comum/hooks/useDeleteImagensAreaComum";

import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useLoading } from "ui/components/GlobalLoading";
import config from "infra/config";
import CustomRUG from "ui/components/Input/CustomRUG/index";

function Fotos({ id }: { id: string }) {
  const { tenant } = useCurrentTenant();

  const { isLoading, data } = useFindAreaComum(tenant.id, id);

  const { mutate: handleDelete } = useDeleteImagensAreaComum(tenant.id, id);

  useLoading(isLoading);

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Fotos
      </Text>





      {!isLoading ? (
        <CustomRUG
          id={0}
          onDeleted={(i: any) => {
            const item = data?.imagens.find((item) => item.url === i.source);

            if (item) {
              handleDelete(item.id as any);
            }
          }}
          initialState={
            data?.imagens.map((item) => ({
              source: item.url,
            })) ?? []
          }
          extraHeaders={{
            tenant: tenant.id,
          }}
          actionUrl={`${config.urlApi}/v1/tenants/${tenant.id}/area-comum/${id}/upload-imagem`}
        />
      ) : null}
    </>
  );
}

export default Fotos;
